// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1-y5d","range":"MonthRangeSwitch_range__2prjK","disabled":"MonthRangeSwitch_disabled__1cyLe"};